export const EventConstants = {
  DEFAULT_SCHEDULE_DAYS_IN_ADVANCE: 183,
  LARGE_NUM_OF_DAYS: 7,
  SMALL_NUM_OF_DAYS: 3,
};
